interface counter {
    theme_id: number;
    errors: number;
}

export const ERRORS_LIMIT: number = 1;

export default class ThemesCounter {
    private readonly _list: counter[];

    constructor() {
        this._list = [];
    }

    private add(theme_id: number, errors?: number) {
        if (theme_id && !errors && theme_id > 0) {
            this._list.push({theme_id, errors: 0});
        } else if (theme_id > 0 && errors && errors > -1) {
            this._list.push({theme_id, errors});
        } else {
            throw Error(`Wrong counter ${theme_id}, ${errors}`);
        }
    }

    private get all(): counter[] {
        return this._list;
    }

    private increment(theme_id: number) {
        const index: number = this.indexOf(theme_id);

        if (index > -1) {
            this._list[index].errors++;
        }
    }

    public update(theme_id: number) {
        try {
            this.increment(theme_id);
        } catch (e) {
            this.add(theme_id);
            this.increment(theme_id);
        }
    }

    private get(theme_id: number): counter {
        if (theme_id > 0) {
            const array: counter[] = this._list.filter(i => i.theme_id === theme_id);

            if (array.length > 0) {
                return array[0];
            } else {
                throw Error(`Counter not found ${theme_id}`);
            }
        } else {
            throw Error(`Wrong id ${theme_id}`);
        }
    }

    private indexOf(theme_id: number): number {
        return this._list.indexOf(this.get(theme_id));
    }

    public get status(): boolean {
        for (const item of this._list) {
            if (item.errors > ERRORS_LIMIT) {
                return false;
            }
        }

        return true;
    }

    public get failures(): number[] | null {
        const array: number[] = [];

        for (const item of this._list) {
            if (item.errors >= ERRORS_LIMIT) {
                array.push(item.theme_id);
            }
        }

        if (array.length > 0) {
            return array;
        } else {
            return null;
        }

    }
}